/**
 * Mando UI initialisation
 */

/* eslint-disable */
import Vue from "NodeModules/vue/dist/vue.min.js";

// Simple observable event bus to allow communication between components
Vue.prototype.$eventBus = new Vue();
import moment from "NodeModules/moment/moment";
import polyfillClosest from "../polyfill";
import header from "Components/consumer/header/header";
import navigationOffCanvas from "Components/consumer/navigation/navigation-off-canvas";
import navigationDropdown from "Components/consumer/navigation-dropdown/navigation-dropdown";
import select from "Components/consumer/forms/select/select";
import search from "Components/consumer/search/search";
import accordion from "Components/consumer/accordion/mando-ui.accordion";
import tabs from "Components/consumer/tabs/mando-ui.tabs";
import table from 'Components/consumer/_rte-table/mando-ui.rte-table';
import cardCarousel from "Components/consumer/card-carousel/card-carousel";
import notify from "Components/consumer/notify/notify";
import videoCarousel from "Components/consumer/video/video-carousel";
import videoThumbnails from "Components/consumer/video/video-thumbnails";
import anchorLinks from "Components/consumer/anchor-links/anchor-links";
import hotspot from "Components/consumer/hotspot/hotspot";
import incidentBanner from "Components/consumer/incident-banner/incident-banner";
import postcode from "Components/consumer/postcode-lookup/postcode";
import searchResults from "Components/consumer/results/SearchResults.vue";
import documentLibrary from "Components/consumer/document-library/DocumentLibrary.vue";
import cardList from "Components/consumer/card-list/CardList.vue";
import layeredMap from 'Components/consumer/layered-map/LayeredMap.vue';
import meteredBill from 'Components/consumer/bill-estimate/MeteredBill.vue';
import jobTracker from 'Components/consumer/job-tracker/JobTracker.vue';
import reportProblem from 'Components/consumer/report-a-problem/_vue/ReportProblem.vue';
import contactUs from 'Components/consumer/contact-us/_vue/ContactUs.vue';
import navigationModal from 'Components/consumer/_navigation-modal/navigation-modal';
import modal from 'Components/consumer/non-rap-modal/non-rap-modal';


document.addEventListener("DOMContentLoaded", () => {
  // Add JS helper class
  document.getElementsByTagName("html")[0].classList.remove("no-js");
  document.getElementsByTagName("html")[0].classList.add("has-js");

  //* Polyfill
  polyfillClosest();
  // Components
  header();
  navigationOffCanvas();
  navigationDropdown();
  navigationModal();
	select();
  search();
  accordion();
  tabs();
  cardCarousel();
  notify();
  videoCarousel();
  videoThumbnails();
  anchorLinks();
  hotspot();
  incidentBanner();
  postcode();
  table();
  modal();

  const searchResultsEl = document.querySelector("#search-results");
  const layeredMapEl = document.querySelector('#layered-map');
  const documentLibraryEl = document.querySelector("#document-library");
  const cardListEl = document.querySelector("#card-list");
  const meteredBillEl = document.querySelector('#bill-estimate');
  const jobTrackerEl = document.querySelector('#job-tracker');
  const reportProblemEl = document.querySelector('#report-a-problem');
  const contactUsEl = document.querySelector('#contact-us');

  Vue.filter("formatDate", (value) => {
    if (!value) {
      return "";
    }
    return moment(value).format("DD/MM/YY");
  });

  Vue.filter("formatFileSize", (value) => {
    return `${(value / Math.pow(1024, 1)).toFixed(2)}kB`;
  });

  Vue.filter("booleanToYesNo", (value) => (value ? "Yes" : "No"));

  if (searchResultsEl) {
    /* eslint-disable no-new */
    new Vue({
      el: "#search-results",
      render: (h) =>
        h(searchResults, {
          props: {
            searchLabel: searchResultsEl.dataset.searchLabel,
            searchDescription: searchResultsEl.dataset.searchDescription,
            sites: JSON.parse(searchResultsEl.dataset.sites),
          },
        }),
    });
    /* eslint-enable */
  }

  if (meteredBillEl) {
    /* eslint-disable no-new */
    new Vue({
      el: '#bill-estimate',
      render: h => h(meteredBill, {
        props: {
          billEstimateTitle: meteredBillEl.dataset.billEstimateTitle,
          billEstimateStep1: meteredBillEl.dataset.billEstimateStep1,
          billEstimateStep2: meteredBillEl.dataset.billEstimateStep2,
          billEstimateImage1: meteredBillEl.dataset.billEstimateImage1,
          billEstimateImage2: meteredBillEl.dataset.billEstimateImage2,
          waterCharge: meteredBillEl.dataset.waterCharge,
          standingWaterCharge: meteredBillEl.dataset.standingWaterCharge,
          standingSewageCharge: meteredBillEl.dataset.standingSewageCharge,
          sewerageCharge: meteredBillEl.dataset.sewerageCharge,
        },
      }),
    });
    /* eslint-enable */
  }

  if (documentLibraryEl) {
    /* eslint-disable no-new */
    new Vue({
      el: '#document-library',
      render: h =>
        h(documentLibrary, {
          props: {
            levelTags: JSON.parse(documentLibraryEl.dataset.levelTags),
            topicTags: JSON.parse(documentLibraryEl.dataset.topicTags),
            heading: documentLibraryEl.dataset.heading,
            componentId: documentLibraryEl.dataset.componentId,
            siteId: documentLibraryEl.dataset.siteId,
            primaryTagsLabel: documentLibraryEl.dataset.primaryTagsLabel,
            secondaryTagsLabel: documentLibraryEl.dataset.secondaryTagsLabel,
            headingTag: documentLibraryEl.dataset.headingTag,
          },
        }),
    });
    /* eslint-enable */
  }

  if (cardListEl) {
    /* eslint-disable no-new */
    new Vue({
      el: '#card-list',
      render: h =>
        h(cardList, {
          props: {
            categoryTags: JSON.parse(cardListEl.dataset.categoryTags),
            topicTags: JSON.parse(cardListEl.dataset.topicTags),
            componentId: cardListEl.dataset.componentId,
            siteId: cardListEl.dataset.siteId,
            textSearch: cardListEl.dataset.textSearch,
            categoryTagsTitle: cardListEl.dataset.categoryTagsTitle,
            topicTagsTitle: cardListEl.dataset.topicTagsTitle,
          },
        }),
    });
    /* eslint-enable */
  }

  if (layeredMapEl) {
    /* eslint-disable no-new */
    new Vue({
      el: '#layered-map',
      render: h => h(layeredMap, {
        props: {
          mapApiKey: layeredMapEl.dataset.mapApiKey,
          config: JSON.parse(layeredMapEl.dataset.config),
        },
      }),
    });
    /* eslint-enable */
  }

  if (jobTrackerEl) {
    /* eslint-disable no-new */
    new Vue({
      el: '#job-tracker',
      render: h => h(jobTracker, {
        props: {
          jobTrackerTitle: jobTrackerEl.dataset.jobTrackerTitle,
          jobTrackerImgUrl: jobTrackerEl.dataset.jobTrackerImgUrl,
          jobTrackerInputLabel: jobTrackerEl.dataset.jobTrackerInputLabel,
          jobTrackerPlaceholder: jobTrackerEl.dataset.jobTrackerPlaceholder,
          jobTrackerButtonText: jobTrackerEl.dataset.jobTrackerButtonText,
          jobTrackerLinkText: jobTrackerEl.dataset.jobTrackerLinkText,
          jobTrackerLink: jobTrackerEl.dataset.jobTrackerLink,
          jobTrackerNoResultsText: jobTrackerEl.dataset.jobTrackerNoResultsText,
          jobTrackerServiceUnavailable: jobTrackerEl.dataset.jobTrackerServiceUnavailable,
          jobTrackerResultsPageUrl: jobTrackerEl.dataset.jobTrackerResultsPageUrl,
        },
      }),
    });
    /* eslint-enable */
  }

  if (reportProblemEl) {
    /* eslint-disable no-new */
    new Vue({
      el: '#report-a-problem',
      render: h => h(reportProblem),
    });
    /* eslint-enable */
  }
  if (contactUsEl) {
    /* eslint-disable no-new */
    new Vue({
      el: '#contact-us',
      render: h => h(contactUs, {
        props: {
          user: contactUsEl.dataset.user ? JSON.parse(contactUsEl.dataset.user) : null,
          content: JSON.parse(contactUsEl.dataset.content),
          panels: JSON.parse(contactUsEl.dataset.panels),
          rapComponentId: contactUsEl.dataset.rapComponentId,
          rapContent: JSON.parse(contactUsEl.dataset.rapContent),
          rapQuestions: JSON.parse(contactUsEl.dataset.rapQuestions),
        },
      }),
    });
    /* eslint-enable */
  }
});



// WEBPACK FOOTER //
// ./src/scripts/brands/consumer.js